// api/authApi.js
import axiosInstance from './axiosConfig';
import ApiConfig from './config';

// ============================================================
// Only forgotPassword lives here.
// Login / Logout / RefreshToken are handled by SessionContext.
// ============================================================

export const forgotPassword = async (email) => {
  try {
    await axiosInstance.put(ApiConfig.ENDPOINTS.FORGOT_PASSWORD, { "username": email });
    return {
      success: true,
      message: 'Password reset instructions have been sent to your email.',
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Failed to send reset instructions.',
    };
  }
};
export const resetPassword = async ({token, confirmPassword }) => {
  try {
    await axiosInstance.put(ApiConfig.ENDPOINTS.RESET_PASSWORD, {
      token,
      password: confirmPassword,
    });
    return {
      success: true,
      message: 'Your password has been reset successfully. Redirecting to login...',
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Failed to reset password. The link may have expired.',
    };
  }
};